export const formatForMapDataViz = (zones, config) => {

  const features = Object.keys(zones).map((zoneId) => {
    const zone = zones[zoneId];

    // fillMethod has script, productValidationValues bound to it further up the data flow
    const fillMethod = config.mapConfig.fillMethod(zone);

    return Object.assign({}, zone.geoJson, {
      displayMeta: {
        fill: fillMethod.fillColor,
        stroke: config.mapConfig.stroke || fillMethod.color,
        strokeWidth: config.mapConfig.strokeWidth || fillMethod.weight
      }
    });
  });

  return {
    crs: { type: 'name', properties: { name: 'EPSG:4326' } },
    type: 'FeatureCollection',
    features
  };
};
